var arrayIsVoid = function (arr) {
	if (typeof arr === 'undefined') { return false; }
	if (arr.length === 0) { return false; }
	return true;
};
export default arrayIsVoid;
